import axios from "../utils/axios";
import API from "../api/api";
//const API = "http://127.0.0.1:8000/api/products";

export const getProduct = async (slug) => {
     console.log(slug);
    const { data } = await axios.get(`${API}/products/${slug}`);
    console.log(data);
    return data.data ?? data;
};

// In your useProduct hook file




//  export const getProduct = async (slug,token) => {
//    console.log("Token:",token)
//     try {
//       const response = await axios.get(`${API}/products/${slug}`, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : '',
//         }
//       });
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   };

 


